import Link from 'next/link';
import React from 'react';

import Text from 'components/Text/Text';
import { useCopyStore } from 'store';
import { ColorNames } from 'utils/styles/theme';

import * as S from './ArticleNextSection.styles';

export interface ArticleNextSectionProps {
  copy: string;
  title: string;
  url: string;
}

const defaultProps: Partial<ArticleNextSectionProps> = {};

const ArticleNextSection: React.FunctionComponent<ArticleNextSectionProps> = ({
  copy,
  title,
  url,
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);

  const hoverTextColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  return (
    <Link href={url} passHref>
      <S.ArticleNextSectionWrapper hoverTextColor={hoverTextColor}>
        <S.ContentWrapper>
          <Text size="smallBody" text={copy} color={ColorNames.codGrayHover} />
          <Text
            as="h2"
            size="heading2"
            text={title}
            color={ColorNames.codGrayHover}
          />
        </S.ContentWrapper>
      </S.ArticleNextSectionWrapper>
    </Link>
  );
};

ArticleNextSection.defaultProps = defaultProps;

export default ArticleNextSection;
